import { TYPES } from 'app/core/models/types.model';
import { Field } from 'app/dynamic-form-builder/models/field.model';

/** Modelo de datos de un cliente */
export interface Customer {
  id: string;
  idClient: string;
  name: string;
  email: string;
  phone: string;
}
/** Campos para la susbscripcion del newsletter en espanol*/
export const CREATE_FIELDS_SECCION_ITEM_ES: Field[] = [
  {
    type: TYPES.text,
    name: 'name',
    label: 'Nombre',
    value: '',
    maxLength: 100,
    required: true,
  },
  {
    type: TYPES.text,
    name: 'email',
    label: 'Correo',
    value: '',
    pattern: '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-z]{2,3}$',
    required: true,
  },
  {
    type: TYPES.number,
    name: 'phone',
    label: 'Teléfono',
    value: '',
    maxLength: 10,
    required: true,
  },
];

/** Campos para la susbscripcion del newsletter en ingles */
export const CREATE_FIELDS_SECCION_ITEM_EN: Field[] = [
  {
    type: TYPES.text,
    name: 'name',
    label: 'Name',
    value: '',
    maxLength: 100,
    required: true,
  },
  {
    type: TYPES.text,
    name: 'email',
    label: 'Email',
    value: '',
    pattern: '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-z]{2,3}$',
    required: true,
  },
  {
    type: TYPES.number,
    name: 'phone',
    label: 'Phone',
    value: '',
    maxLength: 10,
    required: false,
  },
];

/** Campos para formulario de satisfaccion */
export const CREATE_FIELDS_RATE_ES: Field[] = [
  {
    type: TYPES.rating,
    name: 'service',
    label: 'Califica nuestro servicio',
    value: '',
    maxLength: 100,
    required: true,
  },
  {
    type: TYPES.rating,
    name: 'bar',
    label: 'Califica la barra',
    value: '',
    maxLength: 100,
    required: true,
  },
  {
    type: TYPES.rating,
    name: 'food',
    label: 'Califica la cocina',
    value: '',
    maxLength: 100,
    required: true,
  },
  {
    type: TYPES.textarea,
    name: 'comments',
    label: 'Comentarios',
    placeholder: 'Cuentanos mas sobre tu visita.',
    value: '',
    required: false,
  },
];

/** Campos para formulario de satisfaccion */
export const CREATE_FIELDS_RATE_EN: Field[] = [
  {
    type: TYPES.rating,
    name: 'service',
    label: 'Rate our service',
    value: '',
    maxLength: 100,
    required: true,
  },
  {
    type: TYPES.rating,
    name: 'bar',
    label: 'Rate our bar',
    value: '',
    maxLength: 100,
    required: true,
  },
  {
    type: TYPES.rating,
    name: 'food',
    label: 'Rate our food',
    value: '',
    maxLength: 100,
    required: true,
  },
  {
    type: TYPES.textarea,
    name: 'comments',
    label: 'Comments',
    placeholder: 'Cuentanos mas sobre tu visita.',
    value: '',
    required: false,
  },
];

